import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { TextBody, Container, ImageDetail, TitleDetail, WrappDetail, WrappRecomendation, Box, DescriptionSide, Span, Wrapper } from '../../globalStyle'

import Not from '../../assets/images/notfound.svg'
import LeftArrow from '../left-arrow/arrow';
import ImageError from '../error/error';
import { url } from '../../App';
function DetailCertifictes(){
    const {id} = useParams();
    const [ data, setData ] = useState([]);
    const [ data2, setData2 ] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error,setError] = useState(false)

    useEffect(() => {
    
        const CertificateDetail = async() => {
            setLoading(true)
            try{
                let res = await fetch(`${url}/certificate/${id}`)
                let data = await res.json()
                setData(data.data)
            }catch(error){
                setError(true)
            }finally{
                setLoading(false)
            }
        }
        CertificateDetail()
        return()=>{
            CertificateDetail()
        }
    },[id])
    useEffect(() => {
    
        const getCertificate = async() => {
            setLoading(true)
            try{
                let certificataes = await fetch(`${url}/get-certificate`)
                let data2 = await certificataes.json()
                setData2(data2.data)
            }catch(error){
                setError(true)
            }finally{
                setLoading(false)
            }
        }
        getCertificate()
        return()=>{
            getCertificate()
        }
    },[])

   if(error){
       return(
          <ImageError />
       )
   }

    return(
        <>
       
        <Container>
                <Wrapper>
                    <WrappDetail>
                            <ImageDetail src={data ? data.image : Not} alt="Image" />
                            <TitleDetail>{data ? data.nama : 'Mohon maaf Data tidak tersedia !!'}</TitleDetail>
                            <TextBody>{data ? data.body : ""}</TextBody>
                    </WrappDetail>
                    <WrappRecomendation>
                            <p>Rekomendasi :</p>
                            {data &&
                                data2.map(item=>{
                                    return(
                                            item.image ==  data.image ? "" : (
                                                    <Box to={'/certificates/'+item.id} key={item.id}>
                                                        <img src={item.image} width={240} alt="Image data 2" /> 
                                                        <DescriptionSide>{item.body.substr(0,40) + '...'}</DescriptionSide>
                                                        <Span />
                                                    </Box>
                                                )
                                    )
                                })
                            }
                        
                    </WrappRecomendation>
                </Wrapper>                                                                                                   
        </Container>
        </>
    )
}
export default DetailCertifictes 